import { ChangeDetectionStrategy, Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';
import { CustomConfirmationDialogComponent } from '../../custom-confirmation-dialog/custom-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'dl-qn-sbn-side-navigation',
  templateUrl: './qn-sbn-side-navigation.component.html',
  styleUrls: ['./qn-sbn-side-navigation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class QnSbnSideNavigationComponent implements OnInit{

  @Input() public viewMode: string;
  @Output() public updateBtnState = new EventEmitter<{ isPrevState: boolean; isNextState: boolean }>();

  public storedData;
  public isNotiDoc: boolean = true;
  public isRecepient: boolean = true;
  public isMess_Att: boolean = true;
  public isDue_Rem: boolean = true;
  public contactLimitNumber: number = 5000;
  public DueDateEnabled: boolean = true;
  public isDailyReport: boolean = true;
  public isEnableDailyReport: boolean;
  public nonSavedFeedback: boolean = false;
  public isValid: boolean = false;
  public currentRoute: string;
  public fbDisabledAndEnabled: boolean = false;
  public feedbackAdded: boolean = false;
  public feedbackEdited: boolean = false;
  public DocumentEnabled: boolean = true;

  public constructor(
    public _QnSbnService:QnSbnService,
    public _QnSbnDataService:QnSbnDataService,
    private _AppUtils:AppUtils,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private router: Router
  ){}

  public isActive(url: string): boolean {
    return this.currentRoute === url;
  }

  ngOnInit(): void {
     this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      this.currentRoute = event.urlAfterRedirects;
      this.changeDetectorRef.detectChanges();
    }
  });
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      this.storedData = storeData;
    })

    this._QnSbnDataService.DueDateEnabled$.subscribe(
      res =>{
        this.DueDateEnabled = res;
        this.asterixValidation();
      } 
    )
    this._QnSbnDataService.DailyReportEnabled$.subscribe(
      res =>{
        this.isEnableDailyReport = res;
      }
    )

    this._QnSbnDataService.DocumentEnabled$.subscribe(
      res =>{
        this.DocumentEnabled = res;
        this.asterixValidation();
      } 
    )
  }

  isValidDate(dateObject){
    return new Date(dateObject).toString() !== 'Invalid Date';
  }

  public findDuplicates(arr) {
    return arr.filter((target, index) => {
      return (
        arr.some((obj, targetIndex) => 
        index !== targetIndex && 
        obj.customerId === target.customerId &&
        obj.customerEmail === target.customerEmail)
      )
      || (
        arr.some((obj, targetIndex)  => 
        index !== targetIndex && 
        obj.customerId === target.customerId && 
        obj.customerName !== target.customerName)
      ) ;
    });
  }

  public findEmpties(arr) {
    return arr.filter((i)=>{
      if((i.customerContactName===undefined || '' || null) || (i.customerEmail===undefined || '' || null) || (i.customerId===undefined || '' || null) || (i.customerName===undefined || '' || null) || (i.sourceName===undefined || '' || null)){
        return true;
      }
    })
  }

  public updatePrevNextBtnState(isPrev: boolean, isNext: boolean, menu: string, route: string): void {
    this._QnSbnDataService.isAfoBtnDisabled$.subscribe(
      res =>{
        this.nonSavedFeedback = res;
    })
    this._QnSbnDataService.isValidFeedback$.subscribe(
      res =>{
        this.isValid = res;
    })
     this._QnSbnDataService.fbDisabledAndEnabled$.subscribe(
      res =>{
        this.fbDisabledAndEnabled = res;
      } 
    )
    this._QnSbnDataService.isFeedbackAdded$.subscribe(
      res =>{
        this.feedbackAdded = res;
      } 
    )
    this._QnSbnDataService.isEdited$.subscribe(
      res =>{
        this.feedbackEdited = res;
      } 
    )
    if((this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) || 
      (this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded && this.feedbackEdited) ||
      (!this.nonSavedFeedback && this.isValid && this.fbDisabledAndEnabled )){
      const nonSavedFeedbackDialogRef = this.dialog.open(CustomConfirmationDialogComponent, {
        data: {
          title: 'Warning',
          message: 'You have changes not applied in the feedback form controls. Please apply them to continue.',
          confirmButtonText: 'Accept'
        }
      });
      nonSavedFeedbackDialogRef.afterClosed().subscribe((confirmed: boolean) => {
        return
      })
      this._QnSbnDataService.isAfoBtnDisabled$.next(true);
      this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
    }else{
      if (route) {
        this.router.navigate([route]);
      }
      this.updateBtnState.emit({ isPrevState: isPrev, isNextState: isNext });
      this.asterixValidation();
    }
  }

  public asterixValidation() {

    // Notification Documents
    if(this.DocumentEnabled) {
      if(
        ((this.storedData.notificationDoc && !this._QnSbnDataService.isEmpty(this.storedData.notificationDoc)) || (Array.isArray(this.storedData.notificationDocFileList) && this.storedData.notificationDocFileList.length > 0 ))
      ){
        this.isNotiDoc = false;
      }else{
        this.isNotiDoc = true;
      }
    } else {
      // When document toggle is disabled, documents are not required
      this.isNotiDoc = false;
    }
    
    // Recepients
    if(
      (!this._QnSbnDataService.isEmpty(this.storedData.recipientData) && Array.isArray(this.storedData.recipientData.recipientTable) && this.storedData.recipientData.recipientTable.length > 0 && this.storedData.recipientData.recipientTable.length <= this.contactLimitNumber && this.findDuplicates(this.storedData.recipientData.recipientTable).length <= 0  && this.findEmpties(this.storedData.recipientData.recipientTable).length <= 0)
    ){
      this.isRecepient = false;
    }else{
      this.isRecepient = true;
    }

    // Message And Attachments
    if(
      (!this._QnSbnDataService.isEmpty(this.storedData.messageAttachment) && this.storedData.messageAttachment.subjectName && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== "undefined" && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== "")
    ){
      this.isMess_Att = false;
    }else{
      this.isMess_Att = true;
    }
    
    // Due Date And Reminder
    if(this.DueDateEnabled){
      if(
        (!this._QnSbnDataService.isEmpty(this.storedData.feedbackDueDate) && this.isValidDate(this._QnSbnDataService.storageForQnsbn.feedbackDueDate.feedbackDueDate))
      ){
        this.isDue_Rem = false;
      }else{
        this.isDue_Rem = true;
      }
    }else{
      this.isDue_Rem = false;
    }

    // Daily Summary Report
    if(this.isEnableDailyReport){
      if(
        (!this._QnSbnDataService.isEmpty(this.storedData.dailyReportSendTo) && this.storedData.dailyReportSendTo !== "" && Array.isArray(this.storedData.dailyReportContent) && this.storedData.dailyReportContent.length > 0)
      ){
        this.isDailyReport = false;
      }else{
        this.isDailyReport = true;
      }
    }else{
      this.isDailyReport = false;
    }

    this.changeDetectorRef.detectChanges();
  }

}
